import { useTranslation } from "react-i18next";
import { Position, SCBOneOperationRun } from "../../../api/models";
import { PagedApiState } from "../../../api/useApiState";
import "../../../styles/card.scss";
import { BaseDrawer } from "../../BaseDrawer";
import { SelectedOperationRun } from "../../details/SCBOneDetails";
import { SCBOneOperationsRunsTable } from "./OperationRunsTable";

interface OperationRunsDrawerProps {
  operationRuns: PagedApiState<SCBOneOperationRun>;
  positions: Position[];
  positionsLoading: boolean;
  operationRunsDrawerVisible: boolean;
  selectedRow: string | undefined;
  onRowSelected: (selectedRun: SelectedOperationRun) => void;
  onCloseDrawer: (visible: boolean) => void;
}

export function OperationRunsDrawer({
  operationRuns,
  positions,
  positionsLoading,
  operationRunsDrawerVisible,
  selectedRow,
  onRowSelected,
  onCloseDrawer,
}: OperationRunsDrawerProps) {
  const { t } = useTranslation();

  return (
    <BaseDrawer
      title={t("scb-one:operation-runs-title")}
      drawerVisible={operationRunsDrawerVisible}
      onCloseDrawer={() => onCloseDrawer(false)}
      dataTestId="scb-one-operation-runs-drawer"
    >
      <SCBOneOperationsRunsTable
        operationRuns={operationRuns}
        positions={positions}
        positionsLoading={positionsLoading}
        selectedRow={selectedRow}
        onRowSelected={onRowSelected}
      />
    </BaseDrawer>
  );
}
